import { Link } from 'react-router-dom';
import { useScenariosList } from '../../scenario/hooks.js';

/**
 * Planning › Scenario planning. Cross-scenario rollup view —
 * surfaces every scenario with quick links into the per-scenario
 * detail (where notes + KPI rollup + custom data live).
 */
export function PlanningScenarioPlanningPage(): JSX.Element {
  const { data, isLoading, error } = useScenariosList();
  return (
    <div className="relative z-10 flex h-full flex-col">
      <header className="px-6 pb-2 pt-6">
        <h1 className="text-2xl font-light text-foreground">Planning · Scenario planning</h1>
        <p className="text-sm text-foreground/60">
          Quick navigation into every scenario for cross-cutting planning work.
        </p>
      </header>
      <div className="px-6 py-3">
        {isLoading ? (
          <div className="rounded-md border border-foreground/10 bg-foreground/[0.02] p-8 text-center text-sm text-foreground/50">
            Loading…
          </div>
        ) : error ? (
          <div className="rounded-md border border-rose-400/30 bg-rose-500/10 p-4 text-sm text-rose-800 dark:text-rose-200">
            {error.message}
          </div>
        ) : !data || data.length === 0 ? (
          <div className="rounded-md border border-foreground/10 bg-foreground/[0.02] p-8 text-center text-sm text-foreground/50">
            No scenarios yet
          </div>
        ) : (
          <ul className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-3">
            {data.map((row, i) => {
              const id = (row.fusionId ?? row.fusion_id ?? row.id) as string | number | undefined;
              const name = (row.name as string | undefined) ?? `Scenario #${id ?? i}`;
              const team = (row.teamName as string | undefined) ?? '—';
              return (
                <li
                  key={i}
                  className="rounded-md border border-foreground/10 bg-foreground/[0.03] p-3 text-sm"
                >
                  {id !== undefined ? (
                    <Link
                      to={`/scenarios?scenarioId=${encodeURIComponent(String(id))}`}
                      className="font-medium text-foreground hover:underline"
                    >
                      {name}
                    </Link>
                  ) : (
                    <span className="font-medium text-foreground">{name}</span>
                  )}
                  <div className="mt-0.5 text-xs text-foreground/50">Team: {team}</div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}
